import React, { useCallback, useMemo } from 'react';
import { useIntl } from 'react-intl';
import withFilter, { FILTER_KEY } from './withFilter';
import { useHistory } from 'react-router';
import { CART } from 'routers/route-path';
import { messageSuccess } from 'utilities/message';

const withCart = (WrappedComponent) => {
    const WithCart = (props) => {
      const history = useHistory();
      const intl = useIntl();
      const {
        filters: cart = [],
        setFiltersFieldAction: setCartAction,
        paymentType,
        currentBalance = 0,
      } = props;

    const cartTotalPrice = useMemo(() => {
      return Array.isArray(cart)
        ? cart.reduce((acc, cur) => {
            acc += cur.price;
            return acc;
          }, 0)
        : 0;
    }, [cart]);

    const addToCart = useCallback(
      (item, redirect = false) =>
        () => {
          const idx = cart.findIndex((c) => c.id === item.id);
          if (idx < 0) {
            cart.push(item);
            setCartAction([...cart]);
          }
          messageSuccess({
            key: 'addCartSuccess',
            content: intl.formatMessage({ id: 'cart.template_added_to_cart', defaultMessage: 'Template is added to cart' }),
          });
          if (redirect) {
            history.push(CART);
          }
        },
      [cart, intl]
    );

    const removeCartItem = useCallback(
      (item) => {
        cart.splice(
          cart.findIndex((c) => c.id === item.id),
          1
        );
        setCartAction([...cart]);
      },
      [cart]
    );

    const removeCart = useCallback(() => {
      setCartAction([]);
    }, []);

    return (
      <WrappedComponent
        {...props}
        cart={cart}
        cartTotalPrice={cartTotalPrice}
        setCartAction={setCartAction}
        addToCart={addToCart}
        removeCartItem={removeCartItem}
        removeCart={removeCart}
        paymentType={paymentType}
        disabled={paymentType === 'AccountBalance' && cartTotalPrice > currentBalance}
      />
    );
  };
  return withFilter({ filterKey: FILTER_KEY.CART })(WithCart);
};

export default withCart;
